import React, { useState, useRef } from "react";

import { PlayCircle } from "iconsax-react";

import { VideoCloseBtn, VideoWrapper } from "./styledVideoPlayer";

const VideoPlayerComponent = ({
  isSim,
  setShowFunciton,
  hasTrack,
  videoSource,
  subtitleSource,
  enableAutoplay = false,
  ...videoAttributes
}) => {
  const [showControls, setshowControls] = useState(false);
  const videoTagRef = useRef(null);

  const handlePlayingVideo = () => {
    setTimeout(() => {
      if (videoTagRef.current.paused) {
        videoTagRef.current.play();
      } else {
        videoTagRef.current.pause();
      }
    }, 1000);
    setshowControls(true);
  };

  // Check for Arvan videos
  let isArvan = false;
  if (typeof videoSource === "string" && videoSource.includes("arvan"))
    isArvan = true;

  const ArvanIframe = () => {
    return (
      <iframe
        src={`https://player.arvancloud.com/index.html?config=${videoSource}`}
        style={{ border: "0 #ffffff none" }}
        name="درسنامه"
        scrolling="no"
        frameBorder="1"
        marginHeight="0px"
        allow="autoplay; encrypted-media;"
        autoplay
        marginWidth="0px"
        allowFullScreen={true}
        className="w-100"
        {...videoAttributes}
      ></iframe>
    );
  };

  const HtmlVideo = () => {
    if (enableAutoplay === true)
      setshowControls(true)
    return (
      <>
        {!enableAutoplay && isSim && !showControls && (
          <PlayCircle
            variant="Bold"
            color="var(--white-color)"
            size="83"
            className="layer-icon top-50 start-50 translate-middle h-100 position-absolute"
            onClick={!isArvan ? handlePlayingVideo : null}
          />
        )}
        <video
          {...videoAttributes}
          controls={showControls || videoAttributes?.controls}
          ref={videoTagRef}
          autoPlay={enableAutoplay ? true : false}
        >
          <source src={videoSource} type="video/mp4" />
          {hasTrack && <track src={subtitleSource} default />}
        </video>
      </>
    );
  };

  return (
    <VideoWrapper
      className={`position-relative mb-0 ${isSim ? "ratio ratio-16x9" : ""}`}
      $isSim={isSim}
    >
      {isSim && (
        <VideoCloseBtn
          iconSize={33}
          className="position-absolute bg-transparent"
          closeFunction={() => setShowFunciton(false)}
        />
      )}
      {isArvan ? <ArvanIframe /> : <HtmlVideo />}
    </VideoWrapper>
  );
};

export default VideoPlayerComponent;
